import { Controller } from "@hotwired/stimulus"

import 'bootstrap-fileinput'
import 'bootstrap-fileinput/js/locales/pt-BR'
import 'bootstrap-fileinput/themes/bs5/theme'

export default class extends Controller {
  connect() {
    const commonConfig = {
      theme: 'bs5',
      language: 'pt-BR',
      previewFileType: 'any',
      initialPreviewAsData: true,
      showRemove: true,
      showClose: false,
      showUpload: false,
      browseClass: 'btn btn-primary py-6px',
      removeClass: 'btn btn-dark py-6px'
    };

    this.element.querySelectorAll('.imagefileinput').forEach(el => {
      $(el).fileinput({
        ...commonConfig,
        allowedFileExtensions: ['jpg', 'jpeg', 'png', 'webp'],
        initialPreview: $(el).data('url')
      }).on('filecleared', (event) => {
        this._handleFileRemoval(el);
      })
    })

    this.element.querySelectorAll('.anyfileinput').forEach(el => {
      const fileUrl = $(el).data('url');
      const fileName = $(el).data('filename');

      $(el).fileinput({
        ...commonConfig,
        allowedFileExtensions: ['jpg', 'jpeg', 'png', 'webp', 'gif', 'pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'],
        initialPreview: fileUrl,
        initialPreviewConfig: [
          {
            caption: fileName || "Arquivo",
            type: this._inferType(fileUrl),
            height: 'auto',
            width: '120px',
            showRemove: false,
            key: 1
          }
        ]
      });
    });

    this.element.querySelectorAll('.pdffileinput').forEach(el => {
      $(el).fileinput({ ...commonConfig, allowedFileExtensions: ['pdf'] })
    })

    this.element.querySelectorAll('.xlsfileinput').forEach(el => {
      $(el).fileinput({ ...commonConfig, allowedFileExtensions: ['xls', 'xlsx'] })
    })
  }

  _inferType(url) {
    if (!url) return 'image';
    const ext = url.split('.').pop().split(/\#|\?/)[0].toLowerCase();

    if (['jpg', 'jpeg', 'png', 'webp', 'gif'].includes(ext)) return 'image';
    if (ext === 'pdf') return 'pdf';
    if (['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'].includes(ext)) return 'office';

    return 'object';
  }

  _handleFileRemoval(el) {
    const fieldName = el.name.replace(']', '_remove]'); // Transforma person[photo] em person[remove_photo]
    const hiddenInput = document.createElement('input');
    hiddenInput.type = 'hidden';
    hiddenInput.name = fieldName;
    hiddenInput.value = '1';
    el.parentNode.appendChild(hiddenInput);
  }
}